/**
 * msLogin 前端网络配置
 * 使用 @ms/shared-config 统一配置管理
 */

import { getNetworkConfig } from "@ms/shared-config";

// 获取网络配置，明确指定服务名称为 msLogin
export const networkConfig = getNetworkConfig('msLogin');

// 导出配置对象
export const {
  apiBaseUrl,
  corsOrigins,
  isDevelopment,
  isProduction
} = networkConfig;

// 默认导出
export default networkConfig;

// 兼容性导出
export const API_BASE_URL = apiBaseUrl;
